"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 9.4.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FamilyHistoryDtoBrca2TestResultEnum = exports.FamilyHistoryDtoBrca1TestResultEnum = exports.FamilyHistoryDtoRelationshipEnum = void 0;
exports.FamilyHistoryDtoRelationshipEnum = {
    Father: 'Father',
    Mother: 'Mother',
    PaternalGrandmother: 'PaternalGrandmother',
    MaternalGrandmother: 'MaternalGrandmother',
    MaternalAunt: 'MaternalAunt',
    PaternalAunt: 'PaternalAunt',
    Sister: 'Sister',
    Brother: 'Brother',
    Daughter: 'Daughter',
    Niece: 'Niece',
    MaternalAuntFemaleCousin: 'MaternalAuntFemaleCousin',
    PaternalAuntFemaleCousin: 'PaternalAuntFemaleCousin',
    MaternalUncleFemaleCousin: 'MaternalUncleFemaleCousin',
    PaternalUncleFemaleCousin: 'PaternalUncleFemaleCousin',
    MaternalHalfSister: 'MaternalHalfSister',
    PaternalHalfSister: 'PaternalHalfSister'
};
exports.FamilyHistoryDtoBrca1TestResultEnum = {
    Negative: 'Negative',
    Positive: 'Positive',
    Vus: 'VUS'
};
exports.FamilyHistoryDtoBrca2TestResultEnum = {
    Negative: 'Negative',
    Positive: 'Positive',
    Vus: 'VUS'
};
